<template>
  <div class="menu-wrapper">
    <template v-for="item in routes" v-if="!item.hidden&&item.children">
      <router-link v-if="item.children.length===1 && !item.children[0].children&&!item.allowShow"
                   :to="item.path+'/'+item.children[0].path" :key="item.children[0].name">
        <el-menu-item :index="item.path+'/'+item.children[0].path" class='submenu-title-noDropdown'>
          <svg-icon v-if="item.children[0].meta&&item.children[0].meta.icon"
                    :icon-class="item.children[0].meta.icon" class="medium-item-icon"></svg-icon>
          <svg-icon v-if="item.children[0].meta&&item.children[0].meta.hoverIcon"
                    :icon-class="item.children[0].meta.hoverIcon"
                    class="medium-item-icon medium-item-hover-icon"></svg-icon>
          <span v-if="item.children[0].meta&&item.children[0].meta.title">{{ item.children[0].meta.title }}</span>
        </el-menu-item>
      </router-link>
      <el-submenu :index="item.name||item.path" :key="item.name" v-else>
        <template slot="title">
          <svg-icon v-if="item.meta && item.meta.icon"
                    :icon-class="item.meta.icon" class="medium-item-icon"></svg-icon>
          <svg-icon v-if="item.meta && item.meta.hoverIcon"
                    :icon-class="item.meta.hoverIcon"
                    class="medium-item-icon medium-item-hover-icon"></svg-icon>
          <span v-if="item&&item.name">{{ item.name }}</span>
        </template>
        <div class="sub-item-container">
          <template v-for="child in item.children" v-if="!child.hidden">
            <sidebar-item class="nest-menu" v-if="child.children&&child.children.length>0" :routes="[child]"
                          :key="child.path">
            </sidebar-item>
            <router-link v-else :to="item.path+'/'+child.path" :key="child.name">
              <el-menu-item :index="item.path+'/'+child.path">
                <svg-icon v-if="child.meta && child.meta.icon"
                          :icon-class="child.meta.icon" class="medium-item-icon"></svg-icon>
                <svg-icon v-if="child.meta && child.meta.hoverIcon"
                          :icon-class="child.meta.hoverIcon"
                          class="medium-item-icon medium-item-hover-icon"></svg-icon>
                <span v-if="child&&child.name">{{ child.name }}</span>
              </el-menu-item>
            </router-link>
          </template>
        </div>
      </el-submenu>

    </template>
  </div>
</template>

<script>
export default {
  name: 'SidebarItem',
  props: {
    routes: {
      type: Array
    }
  },
}
</script>
<style scoped lang="scss">
.menu-wrapper {
  padding: 15px 10px 15px 16px;
  overflow: hidden;
}

:deep(.el-menu-item) {
  font-size: 14px;
  height: 40px !important;
  line-height: 40px !important;
  border-radius: 8px;
  padding: 0 12px !important;
  color: var(--text-secondary);
  margin-bottom: 4px;
  transition: all 0.2s ease;

  &:hover {
    background-color: var(--sidebar-hover) !important;
    color: var(--text-primary);
  }

  &.is-active {
    background-color: var(--primary-light) !important;
    color: var(--primary) !important;
    font-weight: 500;
  }
}

:deep(.el-menu-item) .medium-item-hover-icon {
  display: none;
}

.el-menu-item {
  padding-left: 12px !important;
  color: var(--text-secondary);
}

.sub-item-container .el-menu-item {
  padding-left: 8px !important;
}

#app .el-submenu .el-menu-item {
  /*background-color: #fff !important;*/
}

:deep(.el-menu-item:hover) {
  background-color: var(--sidebar-hover) !important;
  color: var(--primary) !important;
}

:deep(.el-menu-item.is-active) {
  background-color: var(--primary-light) !important;
  outline: none !important;
}

:deep(.el-menu-item:focus) {
  background-color: transparent !important;
  outline: none !important;
}

:deep(.el-menu-item:hover) .medium-item-icon,
:deep(.el-menu-item.is-active > .medium-item-icon) {
  display: none;
}

:deep(.el-menu-item:hover) .medium-item-hover-icon,
:deep(.el-menu-item.is-active > .medium-item-hover-icon) {
  display: inline;
}

:deep(.el-menu-item) .medium-item-icon {
  width: 18px;
  height: 18px;
}

.svg-icon {
  margin-right: 12px !important;
  position: relative;
  top: 2px;
}

:deep(.el-icon-arrow-down) {
  margin-top: 0;
}

.medium-item-icon {
  display: inline-block !important;
}

.medium-item-hover-icon {
  display: none !important;
}

:deep(.el-submenu.is-active > .el-submenu__title),
:deep(.el-submenu__title:hover) {
  color: var(--primary) !important;
  background-color: var(--sidebar-hover) !important;
  .medium-item-icon {
    display: none !important;
  }
  .medium-item-hover-icon {
    display: inline-block !important;
  }
}

:deep(.el-submenu__title) {
  color: #e5e7eb !important;
  height: 40px !important;
  line-height: 40px !important;
}

.sub-item-container {
  padding-left: 20px;
}

.sub-item-container .el-menu-item .medium-item-hover-icon {
  display: none;
}

.sub-item-container .el-menu-item:hover .medium-item-icon,
.sub-item-container .el-menu-item.is-active > .medium-item-icon {
  display: none;
}

.sub-item-container .el-menu-item:hover .medium-item-hover-icon,
.sub-item-container .el-menu-item.is-active > .medium-item-hover-icon {
  display: inline;
}

.sub-item-container .el-submenu .el-menu-item svg {
  display: none;
}
</style>

<style lang="scss">
// 深色主题样式 - 使用 #app.dark-theme 提高选择器优先级
#app.dark-theme {
  .menu-wrapper {
    // 一级目录默认颜色
    > div > .el-menu > .el-submenu > .el-submenu__title,
    > div > .el-menu > .el-submenu > .el-submenu__title > span {
      color: #e5e7eb !important;
    }

    // 二级目录默认颜色
    .sub-item-container .el-menu-item,
    .sub-item-container .el-menu-item > span {
      color: var(--text-secondary) !important;
    }

    // 一级目录 hover
    > div > .el-menu > .el-submenu > .el-submenu__title:hover,
    > div > .el-menu > .el-submenu > .el-submenu__title:hover > span {
      color: var(--primary) !important;
      background-color: var(--sidebar-hover) !important;
    }

    // 一级目录选中
    > div > .el-menu > .el-submenu.is-active > .el-submenu__title,
    > div > .el-menu > .el-submenu.is-active > .el-submenu__title > span,
    > div > .el-menu > .el-submenu.is-active > .el-submenu__title:focus,
    > div > .el-menu > .el-submenu.is-active > .el-submenu__title:focus > span {
      color: var(--primary) !important;
      background-color: var(--primary-light) !important;
      outline: none !important;
    }

    // 二级目录 hover
    .sub-item-container > .el-menu-item:hover,
    .sub-item-container > .el-menu-item:hover > span {
      color: var(--primary) !important;
      background-color: var(--sidebar-hover) !important;
    }

    // 二级目录选中
    .sub-item-container > .el-menu-item.is-active,
    .sub-item-container > .el-menu-item.is-active > span {
      color: var(--primary) !important;
      background-color: var(--primary-light) !important;
      outline: none !important;
      box-shadow: none !important;
    }

    .sub-item-container > .el-menu-item.is-active::before {
      display: none !important;
    }

    // 箭头图标
    .el-submenu__icon-arrow {
      color: var(--text-muted) !important;
    }
  }
}



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue